









import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component
export default class Toggle extends Vue {
  @Prop() value!: any

  get model() {
    return !!(this.value)
  }

  set model(value) {
    this.$emit('valueChange', !!value)
  }
}
